import { Component, OnInit } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { filter } from 'rxjs/operators';
import { ClientService } from './core/services/client.service';
import {
    FooterComponent,
    HeaderComponent,
    SidenavComponent
} from './shared/components';
import { SvgService } from './shared/material/services';

declare const gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [
        FlexLayoutModule,
        FooterComponent,
        RouterModule,
        HeaderComponent,
        MatSidenavModule,
        SidenavComponent,
        MatButtonModule,
        TranslocoModule
    ]
})
export class AppComponent implements OnInit {
    isApplicationPage = false;

    constructor(
        private readonly _svg: SvgService,
        private readonly _client: ClientService,
        private readonly _router: Router,
        private readonly _title: Title,
        private readonly _transloco: TranslocoService
    ) {
        // runtimeConfig.clientCode and clientId are resolved before bootstrap by
        // provideClientBootstrap() in core/client-bootstrap.ts, so that services reading
        // runtimeConfig.clientId cannot fire requests for client 0.

        // The set itself lives in SvgService (APP_SVG_ICONS) so that a component tested on
        // its own can register the same names without standing up AppComponent.
        this._svg.registerAppIcons();
    }

    ngOnInit(): void {
        this.isApplicationPage = this._router.url.includes('/application');
        this._router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
            .subscribe((e) => {
                this.isApplicationPage =
                    e.urlAfterRedirects.includes('/application');
            });

        this._transloco.langChanges$.subscribe(
            (lang) => (document.documentElement.lang = lang)
        );

        document.addEventListener('focusin', (e) => {
            const el = e.target as HTMLElement;
            el?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
        });

        this._client.latest.subscribe((client) => {
            if (client?.portalName) this._title.setTitle(client.portalName);
        });
        this._client.load();
    }

    focusMainContent(event: Event): void {
        event.preventDefault();
        const mainContent = document.getElementById('main-content');
        mainContent?.focus();
        mainContent?.scrollIntoView({ block: 'nearest' });
    }
}
